import { createStore } from "vuex";
import { auth } from "./auth";
import { files } from "./files";
import { todo } from "./todo";
import { view } from "./view";
import { theme } from "./theme";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    modules: {
        auth,
        files,
        todo,
        view,
        theme   // 추가
    },
    plugins: [
        createPersistedState({
            paths: ["auth", "files", "todo", "view", "theme"], // 추가
        })
    ],
});

export default store;